import { BaseMetaTable } from "./BaseMetaTable";

export class BaseMetaColumn
{
    table: BaseMetaTable;
    name: string;
    text: string;
    type: string; // todo
    required: boolean;
    constructor(table: BaseMetaTable, name: string, text: string, type: string, required: boolean)
    {
        this.table = table;
        this.name = name;
        this.text = text;
        this.type = type;
        this.required = required;
    }
}